interface appConfig {
  baseServiceUrl: string
  builderAppUrl: string
  listingAppUrl: string
  appengineUrl: string
  publicApiUrl: string
  bulkRequestUrl: string
  marketPlaceURL?: string
  newAppEngineUrl: string
  newBuilderURL: string
}
const evn = process.env.mode || 'development'

let appConfig: { [key: string]: appConfig } = {
  development: {
    baseServiceUrl: 'http://localhost:5021',
    appengineUrl: 'https://highlevel-staging.uc.r.appspot.com',
    builderAppUrl: 'http://localhost:3002',
    listingAppUrl: 'http://localhost:3003',
    publicApiUrl: 'https://public-api-dot-highlevel-staging.appspot.com',
    bulkRequestUrl: 'http://localhost:5080/bulk_request/',
    marketPlaceURL: 'http://localhost:5076',
    newAppEngineUrl: 'https://staging.backend.leadconnectorhq.com/appengine',
    newBuilderURL: '',
  },
  staging: {
    baseServiceUrl: 'https://staging.backend.leadconnectorhq.com',
    appengineUrl: 'https://highlevel-staging.uc.r.appspot.com',
    builderAppUrl: 'https://hl-email-builder.web.app',
    listingAppUrl: 'https://hl-email-home.web.app ',
    publicApiUrl: 'https://public-api-dot-highlevel-staging.appspot.com',
    bulkRequestUrl:
      'https://bulk-request-dot-highlevel-staging.appspot.com/bulk_request/',
    marketPlaceURL: 'https://staging.backend.leadconnectorhq.com',
    newAppEngineUrl: 'https://staging.backend.leadconnectorhq.com/appengine',
    newBuilderURL: 'https://hl-email-builder.web.app',
  },
  production: {
    baseServiceUrl: 'https://backend.leadconnectorhq.com',
    appengineUrl: 'https://msgsndr.com',
    publicApiUrl: 'https://rest.gohighlevel.com',
    builderAppUrl: 'https://email-builder-prod.web.app',
    listingAppUrl: 'https://email-home-prod.web.app',
    bulkRequestUrl: 'https://msgsndr.com/bulk_request/',
    marketPlaceURL: 'https://backend.leadconnectorhq.com',
    newAppEngineUrl: 'https://backend.leadconnectorhq.com/appengine',
    newBuilderURL: 'https://email-builder-beta.web.app',
  },
  beta: {
    baseServiceUrl: 'https://backend.leadconnectorhq.com',
    appengineUrl: 'https://msgsndr.com',
    publicApiUrl: 'https://rest.gohighlevel.com',
    builderAppUrl: 'https://email-builder-beta.web.app',
    listingAppUrl: 'https://email-home-beta.web.app',
    bulkRequestUrl: 'https://msgsndr.com/bulk_request/',
    marketPlaceURL: 'https://beta.services.msgsndr.com',
    newAppEngineUrl: 'https://backend.leadconnectorhq.com/appengine',
    newBuilderURL: 'https://email-builder-beta.web.app',
  },
}
const override = false
const overrideConfig = {
  baseServiceUrl: 'http://localhost:5021',
  appengineUrl: 'http://localhost:5000',
  publicApiUrl: 'https://rest.gohighlevel.com',
  builderAppUrl: 'http://localhost:3002',
  listingAppUrl: 'http://localhost:3003',
  bulkRequestUrl: 'https://msgsndr.com/bulk_request/',
  marketPlaceURL: 'http://localhost:5076',
  newAppEngineUrl: 'http://localhost:5000',
}

export default override ? overrideConfig : appConfig[evn]
